import { reactive, provide, inject } from 'vue';

export const stateSymbol = Symbol('state');
export const createState = () => reactive({
    rodzaj: 65535,
    typ: '-',
    miejscowosc: '-',
    dzielnica: '-',
    powierzchniaOd: 1,
    powierzchniaDo: 99999999,
    cenaOd: 1,
    cenaDo: 99999999,
    strona: 1,
    listOffers: {},
    rodo: true
});

export const useState = () => inject(stateSymbol);
export const provideState = () => provide(
    stateSymbol,
    createState()
);